import { SystemField } from "./system-field";
import { AccountingBook } from './accounting-book';
import { User } from "./user";
import { AvailableLang } from "./available-lang";
import { MetadataConfig } from "./metadata-config";
import { ShopCurrency } from "./shop-currency";

export class Company  extends SystemField{
    
	district?:string;
	commune?:string;
	website?:string;
	domain?:string;
	facebook?:string;
	g_plus?:string;
	email?:string;
	instagram?:string;
	pinterest?:string;
	twitter?:string;
	dribble?:string;
	city?:string;
	country?:string;
	phone?:string;
	working_hour?:string;
	mobile?:string;
	is_active?:number;
	store_code?:string;
	aes_key?:string;
	other_phone?:string;
	postcode?:string;
	billing_country?:string;
	billing_city?:string;
	billing_commune?:string;
	billing_district?:string;
	billing_postcode?:string;
	company_type?:string;
	light_logo?:string;
	dark_logo?:string;
	lat?:number;
	log?:number;
	favorite_ico?:string;
	favorite_ico_file?:File;
	youtube?:string;
	linkedin?:string;
	map_embed_link?: string;
	industry?:string;
	industry_field?:string;
	ledger_id?:string;
	record_type_name?:string;
	record_type_id?:string;
	channels?:string;
	base_currency_id?:string;
	default_timezone?:string;

	//Formula Fields
	favorite_ico_preview?: string;
	light_logo_file?:File;
	light_logo_preview?: string;
	dark_logo_file?:File;
	dark_logo_preview?: string;


	products?: string;

	//relationship
	base_currency?:ShopCurrency;
    langs?: any;
	users?:User[];
	available_languages?:AvailableLang[];
	meta_data_configs?:MetadataConfig[];
	shop_currencies?:ShopCurrency[];
    ledger?:AccountingBook;
}
export class CompanyTranslate extends SystemField{
	lang_code?:string;
	address_line?:string;
	billing_address?:string;
	name?:string;
	general_director?:string;
	company_id?:string;
    about?:string;
	keywords?:string;
	vision?:string;
	mission?:string;
}

export class PublicCompany extends Company{}
